/**
 * Strings for friends, blocks and DMs added with the QA fixes of 2026-10-28
 * (area social-dms): the Block and Remove friend confirm sheets, blocked
 * messages and profiles, the blocked-DM bar, closing DMs and managing group
 * DMs.
 *
 * Keys without the `social.` prefix are user-management §3.8 word for word.
 * `social.*` keys are ours, for what the spec does not word.
 */
import type { Dict } from './core';

export const socialEn: Dict = {
  // ---- spec §3.8: friends, block, DMs and group DMs
  'friends.remove': "Remove {name} from your friends? They won't be told.",
  'block.confirm.title': 'Block {name}?',
  'block.confirm.body':
    "They won't be able to message you or send you friend requests, and you'll stop being friends. In voice, you won't hear them. They won't be told.",
  'block.unblock': 'Unblock',
  'block.message': 'Blocked message · Show',
  'dm.close': 'Close DM',
  'gdm.full': 'This group has 10 people, the most a group can have.',
  'gdm.owner': 'Group owner',
  'gdm.transfer': 'Make group owner',
  'gdm.leave': 'Leave group',
  'gdm.name': 'Group name',
  // ---- ours
  'social.block.done': '{name} is blocked.',
  'social.block.undone': '{name} is unblocked.',
  'social.block.hidden': 'You blocked {name}, so their profile is hidden.',
  'social.block.viewAnyway': 'View profile anyway',
  'social.block.dmBar': "You blocked {name}. You can't message each other until you unblock them.",
  'social.fr.self': "That's you. Add a friend by their username.",
  'social.ignore.bodyNotFriend':
    "Their messages will be hidden and their notifications silenced. You can still message each other. They won't be told.",
  'social.gdm.add': 'Add friends to group',
  'social.gdm.members': 'Group members',
  'social.gdm.rename': 'Rename group',
  'social.gdm.renamed': 'Group renamed.',
  'social.gdm.nameHint': "Leave it empty to show the members' names.",
  'social.gdm.leaveTitle': 'Leave {name}?',
  'social.gdm.leaveBody': 'To come back, someone in the group has to add you again.',
  'social.gdm.left': 'You left {name}.',
  'social.gdm.remove': 'Remove from group',
  'social.gdm.removed': 'Removed {name} from the group.',
  'social.gdm.added': {
    one: 'Added {n} friend to the group.',
    other: 'Added {n} friends to the group.',
  },
  'social.gdm.ownerNow': '{name} is the group owner now.',
  'social.gdm.noneToAdd': 'All your friends are in this group already.',
};
